/**
 * Terms of Service Translations Module (Portuguese)
 * 
 * @module terms
 * @language pt
 */

export const terms = {
  pageTitle: "Termos de Serviço",
  heroSubtitle: "Por favor, leia estes termos cuidadosamente antes de usar nossa plataforma.",
  lastUpdated: "Última Atualização: Janeiro de 2026",
  effectiveDate: "Vigência: 1º de Janeiro de 2026",

  intro: {
    title: "Introdução",
    welcome: "Bem-vindo ao Observatório de Futuros da Juventude dos Conselhos de Desenvolvimento JCI (a \"Plataforma\"). Estes Termos de Serviço (\"Termos\") regem seu acesso e uso de nossa plataforma.",
    acceptance: "Ao acessar ou usar esta Plataforma, você concorda em ficar vinculado a estes Termos. Se você não concordar com estes Termos, por favor não use a Plataforma.",
    modifications: "Podemos modificar estes Termos a qualquer momento. O uso continuado da Plataforma após as alterações constitui aceitação dos Termos modificados.",
  },

  eligibility: {
    title: "Elegibilidade",
    age: "Você deve ter pelo menos 18 anos de idade para usar esta Plataforma. Ao usar a Plataforma, você declara e garante que atende a este requisito de idade.",
    membership: "Embora a Plataforma esteja disponível ao público em geral, certos recursos podem ser restritos a membros da JCI ou usuários registrados.",
    accuracy: "Você concorda em fornecer informações precisas, atuais e completas durante o registro e manter e atualizar essas informações.",
  },

  account: {
    title: "Responsabilidades da Conta",
    security: "Você é responsável por manter a confidencialidade de suas credenciais de conta e por todas as atividades que ocorrem em sua conta.",
    notification: "Você deve nos notificar imediatamente sobre qualquer uso não autorizado de sua conta ou qualquer outra violação de segurança.",
    prohibition: "Você não pode compartilhar suas credenciais de conta com outros ou permitir que outros acessem a Plataforma usando sua conta.",
  },

  acceptableUse: {
    title: "Uso Aceitável",
    description: "Você concorda em usar a Plataforma apenas para fins lícitos e de acordo com estes Termos.",
    prohibited: "Você não pode:",
    item1: "Usar a Plataforma para qualquer finalidade ilegal ou não autorizada",
    item2: "Tentar obter acesso não autorizado a sistemas, redes ou dados",
    item3: "Interferir ou interromper a Plataforma ou servidores ou redes conectados a ela",
    item4: "Usar qualquer meio automatizado para acessar a Plataforma ou coletar dados",
    item5: "Transmitir vírus, malware ou outro código prejudicial",
    item6: "Personificar qualquer pessoa ou entidade ou deturpar sua afiliação",
    item7: "Coletar informações pessoais de outros usuários sem consentimento",
    item8: "Usar a Plataforma para spam, phishing ou atividades fraudulentas",
  },

  intellectualProperty: {
    title: "Propriedade Intelectual",
    jciTrademarks: "JCI, Junior Chamber International, o logotipo da JCI e todas as marcas registradas, marcas de serviço e logotipos relacionados são propriedade da Junior Chamber International. Você não pode usar essas marcas sem permissão prévia por escrito.",
    dataLicense: "Dados, visualizações e conteúdo nesta Plataforma são fornecidos sob a Licença Creative Commons Atribuição-NãoComercial-CompartilhaIgual 4.0 Internacional (CC BY-NC-SA 4.0), salvo indicação em contrário.",
    restrictions: "Você não pode usar nossa propriedade intelectual para fins comerciais sem autorização explícita por escrito.",
    platformCredits: "A Plataforma é desenvolvida e mantida pela DashCity em parceria com os Conselhos de Desenvolvimento JCI.",
  },

  dataPrivacy: {
    title: "Dados e Privacidade",
    reference: "Seu uso da Plataforma também é regido por nossa Política de Privacidade, que descreve como coletamos, usamos e protegemos suas informações pessoais.",
    link: "Por favor, revise nossa Política de Privacidade para entender nossas práticas de dados.",
    gdpr: "Estamos comprometidos com a conformidade com o RGPD e respeitamos seus direitos de proteção de dados.",
  },

  thirdParty: {
    title: "Serviços de Terceiros",
    description: "A Plataforma pode conter links para sites ou serviços de terceiros que não são de nossa propriedade ou controlados por nós.",
    disclaimer: "Não temos controle sobre, e não assumimos responsabilidade pelo conteúdo, políticas de privacidade ou práticas de quaisquer sites ou serviços de terceiros.",
    acknowledgment: "Você reconhece e concorda que não seremos responsáveis por quaisquer danos ou perdas causados por ou em conexão com seu uso de qualquer conteúdo, bens ou serviços de terceiros.",
  },

  disclaimers: {
    title: "Isenções de Responsabilidade",
    asIs: "A PLATAFORMA É FORNECIDA \"COMO ESTÁ\" E \"CONFORME DISPONÍVEL\" SEM GARANTIAS DE QUALQUER TIPO, EXPRESSAS OU IMPLÍCITAS.",
    noWarranty: "Não garantimos que a Plataforma será ininterrupta, segura ou livre de erros, ou que quaisquer defeitos serão corrigidos.",
    accuracy: "Embora nos esforcemos para fornecer dados e informações precisas, não fazemos garantias quanto à precisão, completude ou confiabilidade de qualquer conteúdo na Plataforma.",
    research: "Os dados e insights fornecidos são apenas para fins informativos e não devem ser a única base para tomada de decisões.",
  },

  responsibilities: {
    title: "Suas Responsabilidades",
    description: "Você é responsável pelo seu uso da Plataforma e concorda em usá-la de acordo com estes Termos e todas as leis aplicáveis. Você entende que qualquer uso indevido da Plataforma pode resultar no encerramento do seu acesso.",
  },

  governingLaw: {
    title: "Lei Aplicável",
    jurisdiction: "Estes Termos serão regidos e interpretados de acordo com os princípios aplicáveis de direito internacional e as leis da jurisdição onde as operações principais da Plataforma são conduzidas.",
    disputes: "Quaisquer disputas decorrentes destes Termos ou de seu uso da Plataforma serão resolvidas por meio de negociação de boa-fé. Se a negociação falhar, as disputas podem ser submetidas a arbitragem vinculante.",
    severability: "Se qualquer disposição destes Termos for considerada inexequível, as disposições restantes permanecerão em pleno vigor e efeito.",
  },

  termination: {
    title: "Rescisão",
    byUs: "Podemos encerrar ou suspender seu acesso à Plataforma a qualquer momento, com ou sem motivo, e com ou sem aviso prévio.",
    byYou: "Você pode parar de usar a Plataforma a qualquer momento. Se você tiver uma conta, pode excluí-la através da página de Configurações.",
    survival: "As disposições que por sua natureza devem sobreviver à rescisão sobreviverão, incluindo disposições de propriedade intelectual, isenções de responsabilidade e limitações de responsabilidade.",
  },

  contact: {
    title: "Fale Conosco",
    description: "Se você tiver alguma dúvida sobre estes Termos de Serviço, entre em contato conosco:",
    email: "Email: tmariano@jci.cc",
    response: "Nosso objetivo é responder a todas as consultas dentro de 5 dias úteis.",
  },
} as const;
